const Languages = () => import("Core/configuration/languages/views/Languages");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/languages",
            name: "settings_languages",
            component: Languages,
            meta: {
                requiresAuth: true,
                title: "lang.languages",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
